<div 
	[loading]="loading()"
	#searchable="searchable"
	[qSearch]="null"
	[search]="getSearchObs()"
	[(results)]="cardBinder"
	[(searching)]="loading"
	[length]="length"
	[start]="page()"
>
	@if(cardBinder().length){
		<lgb-binder-card-list [backHisto]="true" [references]="references()" [uBinder]="null" [cards]="cardBinder()" [scans]="scans()"></lgb-binder-card-list>
		<div class="pagination mt-4">
			<div class="join">
			  @if(searchable.canPrev()){
		  	  	<button [scrollTo]="0" (click)="searchable.prev()" class="join-item btn">«</button>
		  	  }
			  <button class="join-item btn">Page {{searchable.page()+1}}</button>
			  @if(searchable.canNext()){
			  	<button [scrollTo]="0" (click)="searchable.next()" class="join-item btn">»</button>
			  }
			</div>
		</div>
	}
	@else{
		<img src="img/skin/empty-card.svg"/>
		<div class="empty-container">
			<p class="subtitle">
				Cette liste est vide pour le moment.<br/>
				Ajoute des cartes pour les voir apparaître ici.
			</p>
		</div>
	}
</div>